import { useEffect, useState } from "react";
import { CrudSection } from "./CrudSection";
import { api } from "../../lib/api";

const ROLES = [["boleteria", "Boletería (vende)"], ["conductor", "Conductor (embarque con QR)"], ["taller", "Taller (solo Flota)"]];

export const OfficeUsersPanel = () => {
  const [agencies, setAgencies] = useState([]);
  const [staff, setStaff] = useState([]);
  useEffect(() => {
    api.get("/agencies").then((r) => setAgencies(Array.isArray(r.data) ? r.data.filter((a) => a.type !== "puntoenvio") : [])).catch(() => {});
    api.get("/admin/staff").then((r) => setStaff(Array.isArray(r.data) ? r.data.filter((s) => s.rol === "conductor") : [])).catch(() => {});
  }, []);
  return (
    <div className="space-y-4">
      <p className="max-w-2xl text-sm text-[var(--muted-ink)]">Todos entran en <b>/admin</b> con su email y contraseña. <b>Boletería:</b> vende, reserva, imprime listas y hace su cierre de caja; solo ve las ventas de su boletería. <b>Conductor:</b> ve solo sus viajes asignados, marca la subida escaneando el QR y carga combustible y km. <b>Taller:</b> solo ve Flota (unidades, cubiertas, reparaciones y mantenimiento).</p>
      <CrudSection title="usuario" testid="office-users" endpoint="/admin/users"
        defaults={{ name: "", email: "", role: "boleteria", agency_id: null, staff_id: null, password: "", active: true }}
        fields={[
          { key: "role", label: "Tipo de acceso", type: "select", options: ROLES, wide: true },
          { key: "name", label: "Nombre", required: true, wide: true },
          { key: "email", label: "Email de acceso", type: "email", required: true, wide: true },
          { key: "agency_id", label: "Boletería / agencia", type: "select", options: agencies.map((a) => [a.id, `${a.name} · ${a.city}`]), wide: true, show: (e) => e.role === "boleteria" },
          { key: "staff_id", label: "Conductor (de Personal)", type: "select", options: staff.map((s) => [s.id, `${s.nombre} · DNI ${s.dni}`]), wide: true, show: (e) => e.role === "conductor" },
          { key: "password", label: "Contraseña (mín. 8 · vacío = no cambiar)", type: "password" },
          { key: "active", label: "Acceso habilitado", type: "checkbox" },
        ]}
        render={(u) => (<><p className="font-display-up text-lg">{u.name} <span className="ml-1 rounded-full bg-[var(--paper)] px-2 py-0.5 align-middle font-mono text-[11px]">{u.role}</span></p><p className="text-sm text-[var(--muted-ink)]">{u.email} · {u.office} {!u.active && "· acceso deshabilitado"}</p></>)} />
    </div>
  );
};
